import {
  COMPANY_PENDING_REQUEST_LEAVE_FETCHING,
  COMPANY_PENDING_REQUEST_LEAVE_FAILED,
  COMPANY_PENDING_REQUEST_LEAVE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: [],
  isFetching: true,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case COMPANY_PENDING_REQUEST_LEAVE_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case COMPANY_PENDING_REQUEST_LEAVE_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    case COMPANY_PENDING_REQUEST_LEAVE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}